// @generated by protoc-gen-es v2.2.0 with parameter "target=ts"
// @generated from file nike/clickstream/core/commerce/v1/amount.proto (package nike.clickstream.core.commerce.v1, syntax proto3)
/* eslint-disable */
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
/**
 * Describes the file nike/clickstream/core/commerce/v1/amount.proto.
 */
export const file_nike_clickstream_core_commerce_v1_amount = /*@__PURE__*/ fileDesc("Ci5uaWtlL2NsaWNrc3RyZWFtL2NvcmUvY29tbWVyY2UvdjEvYW1vdW50LnByb3RvEiFuaWtlLmNsaWNrc3RyZWFtLmNvcmUuY29tbWVyY2UudjEiJgoGQW1vdW50Eg0KBXVuaXRzGAEgASgEEg0KBW5hbm9zGAIgASgEQt0BCiVjb20ubmlrZS5jbGlja3N0cmVhbS5jb3JlLmNvbW1lcmNlLnYxQgtBbW91bnRQcm90b1ABogIETkNDQ6oCIU5pa2UuQ2xpY2tzdHJlYW0uQ29yZS5Db21tZXJjZS5WMcoCIU5pa2VcQ2xpY2tzdHJlYW1cQ29yZVxDb21tZXJjZVxWMeICLU5pa2VcQ2xpY2tzdHJlYW1cQ29yZVxDb21tZXJjZVxWMVxHUEJNZXRhZGF0YeoCJU5pa2U6OkNsaWNrc3RyZWFtOjpDb3JlOjpDb21tZXJjZTo6VjFiBnByb3RvMw");
/**
 * Describes the message nike.clickstream.core.commerce.v1.Amount.
 * Use `create(AmountSchema)` to create a new message.
 */
export const AmountSchema = /*@__PURE__*/ messageDesc(file_nike_clickstream_core_commerce_v1_amount, 0);
